module.exports = __webpack_public_path__ + "officialStatic/fonts/PingFangSCMedium.250db73.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/woff2/PingFangSCMedium.woff2
// module id = 0tga
// module chunks = 0